export default function Products() {
  return (
    <section id="products" className="relative min-h-screen bg-[#FAF7F2] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-20">
          <div className="text-sm uppercase tracking-widest text-gray-600 mb-8 font-light">
            BLUE<br/>SKY
          </div>
          <h2 className="text-5xl font-bold text-[#1F1F1F] text-center font-serif">
            Our Product Ecosystem
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-10 mt-32" data-product-shop>
          <div className="bg-[#0A0A0A] rounded-[28px] p-12 flex flex-col justify-between shadow-xl" style={{ height: '520px' }}>
            <div>
              <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mb-8">
                <span className="text-white text-3xl font-semibold">V</span>
              </div>
              <h3 className="text-4xl font-medium text-white text-center mt-20">
                Secure VPN Connection
              </h3>
            </div>
            <p className="text-[#8A8A8A] text-center">
              Military-grade encryption
            </p>
          </div>

          <div className="rounded-[28px] overflow-hidden shadow-xl relative" style={{ height: '520px' }}>
            <img 
              src="https://public.readdy.ai/ai/img_res/46b74bd475a430197fa8c81db70545d7.jpg"
              alt="Security features"
              className="w-full h-full object-cover"
            />
            <div className="absolute top-8 left-8">
              <div className="bg-black/60 backdrop-blur-sm rounded-full px-5 py-2 flex items-center gap-2">
                <i className="ri-shield-check-line text-white text-sm"></i>
                <span className="text-white text-sm">Security</span>
              </div>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <h3 className="text-white text-3xl font-bold">
                Advanced Protection Protocols
              </h3>
            </div>
          </div>

          <div className="bg-white rounded-[28px] p-12 flex flex-col shadow-xl" style={{ height: '520px' }}>
            <div className="mb-8">
              <h3 className="text-4xl font-bold text-[#1F1F1F] mb-4 font-serif">
                Smart Cleaner
              </h3>
              <p className="text-gray-600">
                Optimize device performance
              </p>
            </div>
            <div className="flex-1 rounded-2xl overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 p-8 flex items-center justify-center">
              <div className="text-center">
                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 flex items-center justify-center mx-auto mb-6">
                  <i className="ri-delete-bin-line text-white text-4xl"></i>
                </div>
                <div className="text-5xl font-bold text-gray-900 mb-2">87%</div>
                <div className="text-sm text-gray-600">Storage Optimized</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
